module.exports = __webpack_public_path__ + "static/media/petr-a-pavel.cbad3fa7.jpg";